export default "__VITE_ASSET__3df83838__"